export const MAX_VISIBLE_SIZE = 4.5;
